<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12 pt-0 px-0">
        <div class="col-12 py-1 px-4">
          <h3 class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold">
            Agremiados - {{ typeUserStatus.name }}
          </h3>
          <div class="row">
            <div class="form-group col-12 col-md-8 mb-0 mb-md-4 px-0">
              <div class="d-flex align-items-end">
                <div class="w-50 pr-2">
                  <label for="">Búsqueda</label>
                  <input
                    type="text"
                    placeholder="Buscar"
                    class="form-control form-control-sm mt-1 mb-2"
                    v-model="searchQuery"
                    @keyup="loadElements()"
                  />
                </div>
                <div class="w-50">
                  <label for="">Tipo de Empresa</label>
                  <Multiselect
                    v-model="selectedTypeCompany"
                    style="width: 95%"
                    :options="typesCompany"
                    label="name"
                    placeholder="Tipo de Empresa"
                    :show-labels="false"
                    class="mt-1 mb-2"
                    @input="loadElements()"
                  ></Multiselect>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 p-0 mb-3 pt-md-4 pl-md-5">
              <div class="d-flex justify-content-md-end pt-md-2 pt-0">
                <!-- class="text-white mb-0 mt-md-0 mt-2 btn-new-user border-0" -->
                <button
                  type="button"
                  class="bg-primary text-white font-weight-normal border btn-outline-primary h5 mb-0 btn"
                  @click.prevent="goNew()"
                >
                  Agregar nuevo agremiado
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive card overflow-auto">
            <table class="table table-sm table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">id</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Imagen</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Nombre</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Empresa</div>
                  </th>
                  <th>
                    <div class="font-weight-bold text-center">
                      Tipo de Empresa
                    </div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">
                      Última Acceso
                    </div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Email</div>
                  </th>

                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Acciones</div>
                  </th>
                  <th class="d-none"></th>
                </tr>
              </thead>
              <tbody class=" ">
                <tr
                  class=""
                  v-for="item in users"
                  :key="item.reference"
                  style="cursor: pointer; height: 38px"
                >
                  <td class="text-center">{{ item.id }}</td>
                  <td class="text-center d-flex justify-content-center">
                    <div
                      class="d-flex justify-content-center align-items-center bg-secondary rounded-lg"
                      :class="{
                        'shadow-sm rounded bg-white':
                          item.url_image &&
                          item.url_image !== 'null' &&
                          item.url_image !== null
                      }"
                      style="width: 35px; height: 35px; overflow: hidden"
                      :style="
                        !item.url_image ||
                        item.url_image === 'null' ||
                        item.url_image === null
                          ? { opacity: 0.2 }
                          : ''
                      "
                    >
                      <img
                        v-if="
                          item.url_image &&
                          item.url_image !== 'null' &&
                          item.url_image !== null
                        "
                        :src="item.url_image"
                        alt=""
                        class="rounded-lg shadow-sm"
                        style="width: 100%; height: 100%; object-fit: contain"
                      />
                      <i v-else class="bi bi-file-earmark-image text-white"></i>
                    </div>
                  </td>
                  <td class="text-center">
                    {{ item.first_name }} {{ item.last_name }}
                  </td>
                  <td class="text-center">
                    {{ item.company ? item.company.company_name : '---' }}
                  </td>
                  <td class="text-center">
                    {{
                      item.company && item.company.type_company
                        ? item.company.type_company.name
                        : '---'
                    }}
                  </td>
                  <td class="text-center">
                    {{ formatLastLogin(item.last_login) }}
                  </td>
                  <td class="text-center">{{ item.email }}</td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center w-100">
                      <Tooltip text="Editar">
                        <button
                          class="btn bg-warning border-0 p-2"
                          @click="goEdit(item.id)"
                        >
                          <i
                            class="bi bi-pencil-square text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>

                      <Tooltip
                        :text="item.active === 1 ? 'Desactivar' : 'Activar'"
                      >
                        <button
                          class="btn border-0 mx-1 p-2"
                          :class="{
                            'bg-secondary': item.active === 0,
                            'bg-success': item.active === 1
                          }"
                          @click="changeStatus(item.id, item.active)"
                        >
                          <i
                            v-if="item.active === 1"
                            class="bi bi-check2-circle text-white d-flex justify-content-center align-items-center"
                          ></i>
                          <i
                            v-else
                            class="bi bi-eye-slash text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>

                      <Tooltip text="Eliminar">
                        <button
                          class="btn bg-danger border-0 p-2 h-100"
                          @click="changeStatus(item.id, item.active, true)"
                        >
                          <i
                            class="bi-trash3-fill text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                    </div>
                  </td>
                  <td class="d-none"></td>
                </tr>
              </tbody>
            </table>
            <!--Paginacion-->
            <div class="d-flex justify-content-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage - 1)"
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item" v-for="page in totalPages" :key="page">
                    <a
                      class="page-link"
                      :class="{
                        'bg-primary ': page == currentPage,
                        'text-white': page === currentPage
                      }"
                      href="#"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage + 1)"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import Tooltip from '@/components/Tooltip.vue'

export default {
  components: {
    Multiselect,
    Tooltip
  },
  props: {
    typeUserStatus: {
      type: Object,
      required: true
    }
  },
  watch: {
    typeUserStatus: {
      handler(newVal, oldVal) {
        this.loadElements()
      },
      deep: true
    }
  },
  data() {
    return {
      users: [],
      typesCompany: [],
      selectedTypeCompany: null,
      searchQuery: '',
      currentPage: 1,
      totalPages: 0,
      limit: 20,

      buttonNewUrl: 'MemberNew'
    }
  },
  methods: {
    ...mapActions(['getData', 'changeStatusData']),

    formatLastLogin(last_login) {
      const date = new Date(last_login)
      const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }

      return last_login !== null
        ? date.toLocaleString('es-VE', options).replace(',', '')
        : ''
    },
    async loadTypesCompany() {
      const form = {
        url: 'type_company/all'
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typesCompany = response.data.map((item) => {
              return {
                id: item.id,
                name: item.name
              }
            })
            // this.selectedTypeCompany = this.typesCompany[0]
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async loadElements(page = 1) {
      if (!this.typeUserStatus || !this.typeUserStatus.id) {
        console.warn('typeUserStatus.id is required')
        return
      }
      const form = {
        url: 'user/all',
        params: {
          id_type_user_status: this.typeUserStatus.id,
          id_type_company: this.selectedTypeCompany
            ? this.selectedTypeCompany.id
            : '',
          query: this.searchQuery,
          page: page,
          limit: this.limit
        }
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.users = response.data.data.reverse()
            this.currentPage = response.data.meta.current_page
            this.totalPages = response.data.meta.last_page
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    changeStatus(id, active, isDelete = false) {
      let status
      let message
      if (isDelete) {
        status = 2
        message = '¿Estás seguro de eliminar el usuario agremiado?'
      } else {
        status = active === 0 ? 1 : 0
        message =
          active === 0
            ? '¿Estás seguro de activar el usuario agremiado?'
            : '¿Estás seguro de desactivar el usuario agremiado?'
      }

      const form = {
        url: 'user/change_status',
        id,
        status
      }

      Swal.fire({
        title: 'Advertencia',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200 && status === 0) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del usuario ha sido desactivado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 1) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del usuario ha sido activado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 2) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El usuario ha sido eliminado'
                })
                this.loadElements()
              }
            })
            .catch((error) => {
              console.error(error)
            })
        }
      })
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.loadElements(page)
    },
    goNew() {
      this.$router.push({ name: this.buttonNewUrl })
    },
    goEdit(id) {
      this.$router.push({ name: 'MemberEdit', params: { id: id } })
    }
  },
  mounted() {
    this.loadTypesCompany()
    this.loadElements()
  }
}
</script>
